/**
 * Which chrome the roof view draws over the faces, resolved from the
 * interaction props in one place. The modes are mutually exclusive and
 * ordered — the first that applies wins:
 *
 *  - 'select' — faces clickable/selectable, the selected one editable.
 *  - 'move'   — the "Move whole roof" tool: every outline is a grab handle
 *               for a rigid whole-model drag. It stands alone, because the
 *               tool rail arms it INSTEAD of the select tool: gating it on
 *               `faceEditMode` left the tool with nothing to drag.
 *  - 'vertex' — legacy draggable-corner mode (server repack path).
 *  - 'static' — read-only outlines while a draw tool owns the map clicks.
 *  - 'none'   — view mode: the panels are the star, no face chrome at all.
 */
export type FaceChromeMode = 'select' | 'move' | 'vertex' | 'static' | 'none';

export type FaceChromeModeArgs = {
  faceEditMode?: 'select';
  moveWholeRoof?: boolean;
  editableFaces?: boolean;
  staticFaceOutlines?: boolean;
};

export const resolveFaceChromeMode = ({
  faceEditMode,
  moveWholeRoof,
  editableFaces,
  staticFaceOutlines,
}: FaceChromeModeArgs): FaceChromeMode => {
  if (faceEditMode === 'select') return 'select';
  if (moveWholeRoof) return 'move';
  if (editableFaces) return 'vertex';
  if (staticFaceOutlines) return 'static';
  return 'none';
};
